<template>
  <div class="ui segment" id="logged_summary">
    <div class="summary-head">
      <div class="summary-totals">
        <span class="summary-chip">
          <b>{{ summary.totals.total }}</b> logged
        </span>
        <span
          class="summary-chip"
          v-for="col in summary.columns"
          :key="col.key"
        >
          <b>{{ summary.totals[col.key] }}</b> {{ col.label.toLowerCase() }}
        </span>
      </div>
      <div class="ui small yellow label" v-if="isFiltered">
        Filtered
        <i class="delete icon" @click="clearFilters"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["loggedUsersByProject"]),
    summary() {
      return this.loggedUsersByProject;
    },
    isFiltered() {
      const filters = this.$store.state.users.filters;
      return filters.campaign !== "All" || filters.workStage !== "All";
    },
  },
  methods: {
    clearFilters() {
      this.$store.state.users.filters.campaign = "All";
      this.$store.state.users.filters.workStage = "All";
    },
  },
};
</script>

<style scoped>
#logged_summary {
  margin: 0;
  border-radius: 0;
  padding: 8px 12px;
}

.summary-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px 16px;
}

.summary-totals {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 16px;
}

.summary-chip {
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  white-space: nowrap;
}

.summary-chip b {
  font-size: 1.3em;
  color: rgba(0, 0, 0, 0.87);
  margin-right: 3px;
}
</style>
